import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { DemoModeProvider } from './contexts/DemoModeContext.jsx';
import { RoleProvider } from './contexts/RoleContext.jsx';
import { ToastProvider } from './contexts/ToastContext.jsx';
import './index.css';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <DemoModeProvider>
        <ToastProvider>
          <AuthProvider>
            <RoleProvider>
              <App />
            </RoleProvider>
          </AuthProvider>
        </ToastProvider>
      </DemoModeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
